import React from 'react';
import styled from 'styled-components';

import {
  Section,
  Container,
  Grid,
  Col,
  SanityBlockContent,
  SectionHeader,
} from '../../common';
import { useResponsiveInViewConfigMargin } from '../../../hooks';

import { Sidebar } from '../../layouts';

const StyledHeadline = styled.h2`
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
`;

const StyledLink = styled((props) => <Link {...props} />)`
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
`;

const Article = ({ sanity, page, section }) => {
  const { colors } = sanity;
  const inViewConfigMargin = useResponsiveInViewConfigMargin();

  return (
    <Section
      idName="article"
      padding="lg"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.dark}
      h3Color={colors?.neutral?.dark}
    >
      <Container
        inViewConfigMargin={inViewConfigMargin}
        padding="none"
        classes="max-w-md px-4 lg:px-0 sm:max-w-3xl lg:max-w-7xl"
      >
        {section?.showSidebar ? (
          <Grid
            inViewConfigMargin={inViewConfigMargin}
            classes="lg:grid-cols-5 gap-y-16 lg:gap-24 max-w-7xl"
          >
            <Col classes="order-1 lg:col-span-3 relative">
              <article className="text-lg">
                <SanityBlockContent
                  sanity={sanity}
                  blocks={section?._rawContent}
                />
              </article>
            </Col>
            <Col classes="order-2 hidden lg:flex lg:col-span-2 max-h-min relative">
              <Sidebar sanity={sanity} page={page} section={section} />
            </Col>
          </Grid>
        ) : (
          <Grid
            inViewConfigMargin={inViewConfigMargin}
            classes="lg:grid-cols-1 gap-y-16 lg:gap-24 max-w-7xl"
          >
            <Col classes="order-1 lg:col-span-1 relative max-w-3xl w-full mx-auto">
              <SectionHeader
                sanity={sanity}
                tagline={section?.header?.tagline}
                headline={section?.header?.headline}
                description={section?.header?._rawDescription}
              />
              <article className="text-lg">
                <SanityBlockContent
                  sanity={sanity}
                  blocks={section?._rawContent}
                />
              </article>
            </Col>
          </Grid>
        )}
      </Container>
    </Section>
  );
};

export { Article };
